<template>
    <a-card type="inner" size="small">
        <a-row :gutter="24">
            <a-col :span="12">
                <a-row type="flex" :gutter="[16, 24]">
                    <a-col flex="150px"><strong>Project Title</strong></a-col>
                    <a-col flex="auto">{{ item.title }}</a-col>
                </a-row>
                <a-row type="flex":gutter="[16, 24]">
                    <a-col flex="150px"><strong>Sponsor/Leader</strong></a-col>
                    <a-col flex="auto">{{ item.sponsor }}</a-col>
                </a-row>
                <a-row type="flex":gutter="[16, 24]">
                    <a-col flex="150px"><strong>Objective/Goals</strong></a-col>
                    <a-col flex="auto">
                        {{ item.objective }}
                    </a-col>
                </a-row>
                <a-row type="flex":gutter="[16, 24]">
                    <a-col flex="150px"><strong>Tanggal Mulai</strong></a-col>
                    <a-col flex="auto">
                        {{ moment(item.start_date).format('DD MMMM YYYY') }}
                    </a-col>
                </a-row>
                <a-row type="flex":gutter="[16, 24]">
                    <a-col flex="150px"><strong>Tanggal Selesai</strong></a-col>
                    <a-col flex="auto">
                        {{ moment(item.target_date).format('DD MMMM YYYY') }}
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="12">
                <a-row type="flex" :gutter="[16, 24]">
                    <a-col><strong>Rencana Kerja</strong></a-col>
                </a-row>
                <a-row type="flex" :gutter="[16, 24]">
                    <a-col>
                            {{ item.work_plan }}
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
    </a-card>
</template>

<script>
export default {
    props: {
        charter: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loading: false,
            item: {},
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.project-management.charter.show', {charter: this.charter}) + '?outline=project_evaluation')
                .then(response => {
                    (this.item = response.data)
                    this.charter_id(response.data.id)
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
    },
}
</script>
